import React from "react";
import "./About.css";

export default function About (){
    return (
        <div className="body-about">
        <div className="about-section"> <p>sun seeker. <span className="highlight-text">front-end developer.</span> beach lover. wine drinker. adventure taker.
        <span className="highlight-text">freelance creative.</span> designer. <span className="highlight-text">travel guru.</span>  </p>
       <div className="container">
          
            
        <i class="fab fa-html5 fa-3x tech-icon"></i>
  
        <i class="fab fa-css3-alt fa-3x tech-icon"></i>
        
        <i class="fab fa-js fa-3x tech-icon"></i>
        
        <i class="fab fa-react fa-3x tech-icon"></i>
       
     
        </div>




        </div>
       


        </div>
    )
}